import { timeToMinutes, weekdayOf, type IsoDate, type LocalMoment } from "./dates.js";

export interface HabitSchedule {
  /** Weekdays the habit repeats on, 0 = Sunday … 6 = Saturday. */
  daysOfWeek: number[];
  /** "HH:mm" local time. */
  time: string;
  startDate: IsoDate;
  endDate: IsoDate | null;
}

export function isScheduledOn(habit: HabitSchedule, date: IsoDate): boolean {
  if (date < habit.startDate) return false;
  if (habit.endDate && date > habit.endDate) return false;
  return habit.daysOfWeek.includes(weekdayOf(date));
}

/**
 * How late a reminder may still go out. The job ticks every minute, but a deploy or a
 * restart can skip a tick; a few minutes late beats silently dropping the reminder.
 * Past this window the moment has passed and a notification would just be noise.
 */
export const REMINDER_GRACE_MINUTES = 10;

export function isReminderDue(habit: HabitSchedule, now: LocalMoment): boolean {
  if (!isScheduledOn(habit, now.date)) return false;
  const late = now.minutes - timeToMinutes(habit.time);
  return late >= 0 && late <= REMINDER_GRACE_MINUTES;
}
